import React, { ChangeEvent, useContext, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { notify } from 'components/common/Toast/toast.helpers';
import Button from 'components/common/Button/Button';
import TextInput from 'components/common/TextInput/TextInput';
import { validateEmail } from 'components/auth/authValidation.utils';
import { VectorIcon } from 'components/common/Icons/Icons';
import { RootStoreContext } from 'index';
import { ErrorMessage } from 'common/enums/errorMessages.enums';

import styles from './RequestResetPasswordPage.module.scss';

const RequestResetPasswordPage = () => {
  const { authStore } = useContext(RootStoreContext);
  const {
    authStore: { isLoading },
  } = useContext(RootStoreContext);
  const navigator = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSecondPage, setSecondPage] = useState(false);
  const handleRequestReset = async () => {
    setError(validateEmail(email));

    if (validateEmail(email)) {
      return;
    }

    const { success } = await authStore.requestResetPassword(email);

    if (success) {
      setSecondPage(true);
    } else {
      notify(ErrorMessage.UnknownError, 'error');
    }
  };

  const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    setError(validateEmail(event.target.value));
    setEmail(event.target.value);
  };

  const onClickBack = () => navigator(-1);

  return (
    <div className={styles.main}>
      {isSecondPage ? (
        <>
          <h3>We’ve sent a reset password link to {email}.</h3>
          <h3>Please follow it to continue</h3>
        </>
      ) : (
        <>
          <h3 className={styles.title}>
            <VectorIcon className={styles.backButton} onClick={onClickBack} />
            Forgot Password?
          </h3>
          <p className={styles.text}>Please enter your email.</p>
          <div className={styles.form}>
            <TextInput
              labelTitle="Email"
              onChange={onChangeInput}
              value={email}
              tabIndex={1}
              errorMessage={error}
              error={!!error}
              containerClassName={styles.emailInput}
            />
            <div className={styles.buttonsLayout}>
              <Button className={styles.button} onClick={handleRequestReset} disabled={isLoading} isLoading={isLoading}>
                Reset Password
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default observer(RequestResetPasswordPage);
